import { sizing } from "ds/materials/metrics";
import { disabledFlagStyle } from "./index";

export default function DevFlag({ active }: { active?: boolean }) {
  const baseStyle = { fontSize: sizing(3) };
  const style = { ...baseStyle, ...(!active ? disabledFlagStyle : {}) };
  return <span style={style}>🗺️</span>;
}
